"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const typography_1 = require("../typography");
const styles_1 = require("./styles");
exports.Tag = (0, react_1.forwardRef)((props, ref) => {
    if (props.size === 'small') {
        return ((0, jsx_runtime_1.jsx)(styles_1.StyledSmallTag, { alignItem: "center", justifyContent: "center", ref: ref, ...props, "data-testid": "tag-small-wrapper", children: (0, jsx_runtime_1.jsx)(typography_1.Typography, { variant: "button", size: "normal", "data-testid": "tag-small-label", children: props.label }) }));
    }
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledTag, { alignItems: "center", justifyContent: "center", ref: ref, ...props, "data-testid": "tag-normal-wrapper", children: (0, jsx_runtime_1.jsx)(typography_1.Typography, { variant: "button", size: "small", "data-testid": "tag-normal-label", children: props.label }) }));
});
exports.Tag.displayName = 'Tag';
exports.default = exports.Tag;
//# sourceMappingURL=tag.js.map